<template>
  <div>
    <p>
      The spacecraft is required to deploy the constellation, but is not used to
      perform a performance analysis of the constellation. <br />
      The spacecrafts from the parametric studies can be used, except those
      which are parametrics.
    </p>
  </div>
</template>

<script>
export default {
  name: 'tooltipConstellationGeometrySpacecraft'
}
</script>
